module.exports = __webpack_public_path__ + "static/7-jaysom-443d118a229cf5302ce38509f5a325c2.jpg";